import React, { useContext } from 'react';
import { BudgetContext } from '../BudgetStatusProvider/BudgetStatusProvider';
import { BudgetStatus } from '../../types';
import budgetStatusMap from './budgetStatusMap';
import Text from '@ramsey-design-system/text';
import Button from '@ramsey-design-system/button';
import Heading from '@ramsey-design-system/heading';
import Stack from '@ramsey-design-system/stack';

// Styles
import '@ramsey-design-system/text/dist/text.css';
import '@ramsey-design-system/button/dist/button.css';
import '@ramsey-design-system/heading/dist/heading.css';
import '@ramsey-design-system/stack/dist/stack.css';
import styles from './budget-status-tile.module.css';

function BudgetStatusTile() {
  const { status, untrackedTransactions, forceUpdate } = useContext(
    BudgetContext
  );
  return (
    <BudgetStatusTileUI
      status={status}
      untrackedTransactions={untrackedTransactions}
      forceUpdate={forceUpdate}
    />
  );
}

type BudgetStatusTileProps = {
  status: BudgetStatus;
  untrackedTransactions?: number;
  forceUpdate?: () => void;
};

function BudgetStatusTileUI({
  status,
  forceUpdate,
  untrackedTransactions = 0,
}: BudgetStatusTileProps) {
  const { img, heading, text, buttons } = budgetStatusMap(
    status,
    untrackedTransactions
  );

  return (
    <div className={styles.container}>
      <div className={styles.budgetStatusText}>
        <Heading
          className={styles.heading}
          level="2"
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        <Text color="subdued" size="bodySmall" className={styles.text}>
          {text}
        </Text>
        <Stack>
          {buttons.map(({ cta, appearance, href, onClick }) => {
            const target = href ? { target: '_blank' } : {};
            return (
              <Button
                key={cta}
                href={href}
                {...target}
                appearance={appearance}
                data-logger-element-id="Budget Status Tile"
                data-logger-element-label={`Budget Status: ${status}`}
                onClick={() => {
                  if (onClick) {
                    onClick();
                    forceUpdate && forceUpdate();
                  }
                }}
              >
                {cta}
              </Button>
            );
          })}
        </Stack>
      </div>
      <div className={styles.imageContainer}>
        <img src={img} alt="" />
      </div>
    </div>
  );
}

export default BudgetStatusTile;
export { BudgetStatusTileUI };
